import { useTranslation } from 'react-i18next';
import { Fragment, useMemo } from 'react';

import _ from 'lodash';

import { useFlightTicketRequests } from 'entities/Flights/sdk';

import Navigation from 'components/Navigation';
import PageContent from 'components/PageContent';
import FlightBox from 'pages/Flights/FlightBox';
import { FlightTicketProposalStatusEnum } from 'utils/constants';
import Footer from 'components/Footer';
import Loader from 'components/Loader';
import { H1, H3, P } from 'components/ui/typography.tsx';

const Flights = () => {
  const { t } = useTranslation();
  const { data: flightTicketRequests, isLoading } = useFlightTicketRequests();

  const upcomingFlights = useMemo(
    () =>
      _.filter(
        flightTicketRequests,
        (flightTicketRequest) => flightTicketRequest.computed_status !== FlightTicketProposalStatusEnum.OPERATED
      ),
    [flightTicketRequests]
  );

  const pastFlights = useMemo(
    () =>
      _.filter(
        flightTicketRequests,
        (flightTicketRequest) => flightTicketRequest.computed_status === FlightTicketProposalStatusEnum.OPERATED
      ),
    [flightTicketRequests]
  );

  return (
    <Fragment>
      <Navigation />
      <PageContent>
        <H1>{t('flights.title')}</H1>
        {isLoading ? (
          <div className='flex flex-1 items-center justify-center h-full'>
            <Loader className='size-20 text-content-primary' />
          </div>
        ) : (
          <div className='pt-[28px] flex flex-col gap-[8px] mt-6'>
            {flightTicketRequests?.length! > 0 ? (
              <H3 className='mb-6'>{t('flights.upcoming')}</H3>
            ) : (
              <P className='font-[MuseoSansCyrl] mt-6 '>{t('flights.noFlights')}</P>
            )}

            <div className='flex flex-row gap-6 max-sm:flex-col flex-wrap max-sm:justify-center max-sm:items-center'>
              {_.map(upcomingFlights, (flightTicketRequest, index) => (
                <FlightBox key={index} flightTicketRequest={flightTicketRequest} />
              ))}
            </div>

            {!_.isEmpty(pastFlights) && (
              <Fragment>
                <H3 className='mb-6'>{t('flights.past')}</H3>{' '}
                <div className='flex flex-row gap-6 max-sm:flex-col flex-wrap max-sm:justify-center max-sm:items-center'>
                  {_.map(pastFlights, (flightTicketRequest) => (
                    <FlightBox flightTicketRequest={flightTicketRequest} />
                  ))}
                </div>
              </Fragment>
            )}
          </div>
        )}
      </PageContent>
      <Footer />
    </Fragment>
  );
};

export default Flights;
